<template>
  <NavBarWeb />
  <div class="" style="text-align: left">
    <div class="sectionKoko">
      <div class="container">
        <div class="row mt-5">
          <div
            class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mt-5"
            style="text-align: left"
            id="app"
          >
            <p>
              <span ref="downloadSms" class="heroline1">
                {{ $t("c.header1") }}
              </span>
            </p>

            <p>
              <span class="heroline2">
                {{ $t("c.header1_a") }}
              </span>
            </p>
            <div class="d-none d-sm-block">
              <div class="row mt-3">
                <!-- <div class="btn btn-primary kokoWebButtons mt-2">
                 <span style="color: #ffffff; font-size: 14px; font-weight: bold"
                   >Coming soon</span
                 >
               </div> -->
              </div>
              <div class="row mt-3">
                <!-- <div class="btn btn-primary kokoWebButtons mt-2">
                 <span style="color: #ffffff; font-size: 14px; font-weight: bold"
                   >Coming soon</span
                 >
               </div> -->

                <div class="col" style="width: 200px;">
                  <a
                    href="https://apps.apple.com/lk/app/koko-buy-now-pay-later/id1568237541"
                  >
                    <img src="../assets/images/app-store-badge.webp" width="150"
                  /></a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.sl.koko.bnpl"
                  >
                    <img
                      src="../assets/images/play-store-badge.png"
                      width="150"
                      style="margin-left: 10px;"
                  /></a>
                </div>
              </div>
            </div>

            <div class="d-block d-sm-none">
              <a href="http://onelink.to/yhyq66">
                <div
                  class="btn kokoWebButtons mt-2"
                  style="width: 300px; position: relative;"
                >
                  <span
                    class="center"
                    style="color: #ffffff; font-size: 14px; font-weight: bold"
                  >
                    DOWNLOAD APP
                  </span>
                </div>
              </a>
            </div>

            <!--          <router-link to="/earlyaccess">-->
            <!--            <div class="btn btn-primary kokoWebButtons">-->
            <!--              <span style="color:#FFFFFF ; font-size: 14px; font-weight: bold;">APPLY FOR EARLY ACCESS</span>-->
            <!--            </div>-->
            <!--          </router-link>-->
          </div>
          <div
            class="col-xl-6 col-lg-6 col-md-12 col-sm-12 align-middle text-right mt-5"
            id="event-with-method"
          >
            <div
              style="padding:56.25% 0 0 0;position:relative; max-height: 400px; height: 100%;"
            >
              <iframe
                class="center"
                src="https://player.vimeo.com/video/566919485?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                style="width:100%;height:100%;"
                title="Koko: Buy Now Pay Later"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sectionKoko" style="background-color: #f1fbff">
      <div class="container">
        <div class="row" style="margin: auto;">
          <div class="col-lg-4 col-md-6 col-xs-12">
            <div style="max-width: 300px; text-align: center; margin: auto;">
              <img
                src="../assets/images/QuickStart.png"
                alt="quick-start"
              /><br />
              <div class="iconExpHead">{{ $t("c.header2_title1") }}</div>
              <div class="iconExpBody">{{ $t("c.header2_title1_a") }}</div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-xs-12">
            <div style="max-width: 300px; text-align: center; margin: auto;">
              <img
                src="../assets/images/simpInstallments.png"
                alt="simple-installments"
              /><br />
              <div class="iconExpHead">{{ $t("c.header2_title2") }}</div>
              <div class="iconExpBody">{{ $t("c.header2_title2_a") }}</div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-xs-12">
            <div style="max-width: 300px; text-align: center; margin: auto;">
              <img src="../assets/images/Instant.png" alt="instant" /><br />
              <div class="iconExpHead">{{ $t("c.header2_title3") }}</div>
              <div class="iconExpBody">{{ $t("c.header2_title3_a") }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sectionKoko" style="background-color: #f1eaff">
      <div class="container" style="padding-top: 40px; max-width: 800px">
        <div class="row">
          <div class="col-sm-6" style="text-align: center">
            <img
              src="../assets/images/portraitPhone.webp"
              alt="portrait-phone"
              style="width: 80%; max-width: 350px; margin-top: -50px"
            />
          </div>
          <div class="col-sm-6">
            <div class="sectionHead mt-5">{{ $t("c.header3") }}</div>
            <div class="sectionBody">{{ $t("c.header3_a") }}</div>
            <!-- 
            <div class="d-none d-sm-block">
              <div
                class="btn btn-primary kokoWebButtons mt-4"
                @click="scrollMeTo('downloadSms')"
              >
                <span
                  style="color: #ffffff; font-size: 14px; font-weight: bold"
                >
                  GET EARLY ACCESS
                </span>
              </div>
            </div> -->
            <div class="d-block d-sm-none">
              <a href="http://onelink.to/yhyq66">
                <div
                  class="btn kokoWebButtons mt-2"
                  style="width: 300px; position: relative;"
                >
                  <span
                    class="center"
                    style="color: #ffffff; font-size: 14px; font-weight: bold"
                  >
                    DOWNLOAD APP
                  </span>
                </div>
              </a>
            </div>

            <div
              style="height:60px;background-color:#ffffff;border-radius: 5px;box-shadow: 0 3px 10px rgb(0 0 0 / 20%);display:none;"
            >
              <table style="width:100%;">
                <tr style="width:100%;">
                  <td style="width:30%;">
                    <img
                      src="https://img.alicdn.com/imgextra/i2/O1CN01i1rVf41o5jz0dvN4X_!!6000000005174-2-tps-215-98.png"
                      style="height: 40px;width: 90px;margin-left: 9%;margin-top: -5%;"
                    />
                  </td>
                  <td style="width:70%;">
                    <p
                      style="font-style: normal;font-weight: 300;font-size: 14px;margin-top:2%;"
                    >
                      Pay in 3 instalments of
                      <a style="font-weight:900"> LKR 100,000</a>
                      <br />
                      0% interest |
                      <a
                        href="https://paykoko.com/iframe-education"
                        style="text-decoration:underline;"
                        >Learn more</a
                      >
                    </p>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sectionKoko" style="background-color: lavenderblush">
      <div class="container">
        <div class="sectionIntro">
          <div class="sectionHead">{{ $t("c.kokoHowWorks") }}</div>
          <!--          <div class="sectionBody">{{ $t("c.headerHowWorks_a") }}</div>-->
        </div>
        <div class="row mt-3">
          <div class="col-lg-3 col-sm-6 col-xs-12 mt-3">
            <div class="stepperHead">{{ $t("c.step") }} 1</div>
            <div class="stepperBody">
              {{ $t("c.step1Body") }}
            </div>
          </div>
          <div class="col-lg-3 col-sm-6 col-xs-12 mt-3">
            <div class="stepperHead">{{ $t("c.step") }} 2</div>
            <div class="stepperBody">
              {{ $t("c.step2Body") }}
            </div>
          </div>
          <div class="col-lg-3 col-sm-6 col-xs-12 mt-3">
            <div class="stepperHead">{{ $t("c.step") }} 3</div>
            <div class="stepperBody">
              {{ $t("c.step3Body") }}
            </div>
          </div>
          <div class="col-lg-3 col-sm-6 col-xs-12 mt-3">
            <div class="stepperHead">{{ $t("c.step") }} 4</div>
            <div class="stepperBody">
              {{ $t("c.step4Body") }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sectionKoko">
      <div class="container">
        <div class="sectionIntro">
          <div class="sectionHead">{{ $t("c.header4_title1") }}</div>
          <div class="sectionBody">{{ $t("c.header4_title1_a") }}</div>
        </div>
        <div class="d-none">
          <Carousel
            :settings="settings"
            class="home"
            :breakpoints="breakpoints"
          >
            <Slide v-for="slide in slide" :key="slide" class="carousel__item">
              <MerRectDispWeb :id="slide.message" />
            </Slide>
            <template #addons>
              <Navigation>
                <!--              <template #next>-->
                <!--                <span> >> </span>-->
                <!--              </template>-->
                <!--              <template #prev>-->
                <!--                <span> back </span>-->
                <!--              </template>-->
              </Navigation>

              <Pagination />
            </template>
          </Carousel>
        </div>
        <div class="row mt-4">
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="2302" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="368" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="118" />
          </div>         
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="312" />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="31" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="23" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="20" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="628" />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="17" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="36" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="575" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="19" />
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-sm">
            <div class="sectionHead">{{ $t("c.header4_title2") }}</div>
            <div class="sectionBody">{{ $t("c.header4_title2_a") }}</div>
          </div>
          <div class="col-sm"></div>
        </div>

        <router-link to="/category?cattype=fashion">
          <div
            class="btn kokoWebButtons mt-2"
            style="background-color: #000000; width: 200px"
          >
            <span style="color: #ffffff; font-size: 14px; font-weight: bold"
              >VIEW ALL</span
            >
          </div>
        </router-link>

        <div class="row mt-4">
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="520" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="209" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="784" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="232" />
          </div>
        </div>

        <div class="sectionHead mt-5">{{ $t("c.header4_title3") }}</div>
        <div class="sectionBody">{{ $t("c.header4_title3_a") }}</div>
        <router-link to="/category?cattype=electronics">
          <div
            class="btn kokoWebButtons mt-2"
            style="background-color: #000000; width: 200px"
          >
            <span style="color: #ffffff; font-size: 14px; font-weight: bold"
              >VIEW ALL</span
            >
          </div>
        </router-link>
        <div class="row mt-4">
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="23" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="118" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="12" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="341" />
          </div>
        </div>

        <div class="sectionHead mt-5">{{ $t("c.header4_title4") }}</div>
        <div class="sectionBody">{{ $t("c.header4_title4_a") }}</div>
        <router-link to="/category?cattype=lifestyle">
          <div
            class="btn kokoWebButtons mt-2"
            style="background-color: #000000; width: 200px"
          >
            <span style="color: #ffffff; font-size: 14px; font-weight: bold"
              >VIEW ALL</span
            >
          </div>
        </router-link>
        <div class="row mt-4">
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="45" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="97" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="55" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <MerRectDispWeb id="210" />
          </div>
        </div>
      </div>
    </div>

    <div class="sectionKoko" style="background-color: #f1eaff">
      <div class="container">
        <div class="sectionHead">
          {{ $t("c.header5") }}
        </div>
        <div class="mt-5">
          <span
            class="faqHeader"
            data-toggle="collapse"
            href="#collapseExample1"
            role="button"
            aria-expanded="false"
            aria-controls="collapseExample1"
          >
            <p>
              {{ $t("c.header5_title1") }}
            </p>
          </span>
          <div class="collapse" id="collapseExample1">
            <span class="faqText">
              <p>
                {{ $t("c.header5_title1_a") }}
              </p>
            </span>
          </div>
        </div>
        <div class="mt-5">
          <span
            class="faqHeader"
            data-toggle="collapse"
            href="#collapseExample2"
            role="button"
            aria-expanded="false"
            aria-controls="collapseExample2"
          >
            <p>
              {{ $t("c.header5_title2") }}
            </p>
          </span>
          <div class="collapse" id="collapseExample2">
            <span class="faqText">
              <p>
                {{ $t("c.header5_title2_a") }}
              </p>
            </span>
          </div>
        </div>
        <div class="mt-5">
          <span
            class="faqHeader"
            data-toggle="collapse"
            href="#collapseExample3"
            role="button"
            aria-expanded="false"
            aria-controls="collapseExample3"
          >
            <p>
              {{ $t("c.header5_title3") }}
            </p>
          </span>
          <div class="collapse" id="collapseExample3">
            <span class="faqText">
              <p>
                {{ $t("c.header5_title3_a") }}
              </p>
            </span>
          </div>
        </div>

        <div class="mt-5">
          <span
            class="faqHeader"
            data-toggle="collapse"
            href="#collapseExample4"
            role="button"
            aria-expanded="false"
            aria-controls="collapseExample4"
          >
            <p>
              {{ $t("c.header5_title4") }}
            </p>
          </span>
          <div class="collapse" id="collapseExample4">
            <span class="faqText">
              <p>
                {{ $t("c.header5_title4_a") }}
              </p>
            </span>
          </div>
        </div>
      </div>
    </div>
    <FooterWeb />
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

import MerRectDispWeb from "@/components/MerRectDispWeb";
import NavBarWeb from "@/components/NavBarWeb";
import FooterWeb from "@/components/FooterWeb";
// import HomeVideoSwap from "@/components/HomeVideoSwap"
// import HomeVideoSwapped from "@/components/HomeVideoSwapped"
// import SMSModule from "../components/SMSModule";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default {
  name: "Home",

  created() {
    document.title = "Buy Now Pay Later with Koko";

    window.fwSettings = {
      widget_id: 80000005144,
    };
    !(function() {
      if ("function" != typeof window.FreshworksWidget) {
        var n = function() {
          n.q.push(arguments);
        };
        (n.q = []), (window.FreshworksWidget = n);
      }
    })();
  },
  components: {
    // SMSModule,
    FooterWeb,
    NavBarWeb,
    MerRectDispWeb,
    Carousel,
    Slide,
    Navigation,
  },
  data() {
    return {
      // slide: [
      //   { message: "5" },
      //   { message: "7" },
      //   { message: "4" },
      //   { message: "8" },
      //   { message: "5" },
      //   { message: "6" },
      // ],

      settings: {
        itemsToShow: 1.2,
      },
      // breakpoints are mobile first
      // any settings not specified will fallback to the carousel settings
      breakpoints: {
        // 700px and up
        700: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 4,
          snapAlign: "start",
        },
      },
    };
  },
  methods: {
    scrollMeTo(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    },
  },
  mounted() {},
  setup() {},
  // computed: {
  //   currentTabComponent() {
  //     return this.currentTab
  //   }
  // },
  // methods: {
  //   swapComponent: function()
  //   {
  //     this.currentTab = HomeVideoSwapped;
  //
  //   },

  // }
};
</script>

<style scoped>
.responsive-iframe {
  position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.carousel__item {
  min-height: 200px;
  width: 100%;
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}

.heroline1 {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 50px;
  line-height: 50px;

  color: #393939;
}

.heroline2 {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;

  color: #393939;
}

.primaryButton {
  width: 200px;
  height: 45px;
  left: 225px;
  top: 426px;

  background: #2d3a53;
  text-decoration: none;
}

.iconExpHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  /* line-height: 22px; */
  color: #393939;
}

.iconExpBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
  text-align: center;
}

.faqHeader {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  /* line-height: 22px; */
  color: #393939;
}

.faqText {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
}
.sectionHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  /* line-height: 42px; */

  color: #393939;
}
.sectionHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  /* line-height: 42px; */

  color: #393939;
}

.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #393939;

  opacity: 0.8;
}

.sectionIntro {
  max-width: 500px;
}

.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
  padding: 5%;
}

.stepHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  color: #393939;
}

.stepBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;

  color: #767676;
  padding-top: 6px;
  padding-bottom: 20px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
  text-decoration: none;
}

.kokoWebButtons {
  background-color: #000000;
  border: 0;
  height: 40px;
  font-weight: bolder;
}

.playicon {
  position: relative;
}

.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.stepperHead {
  font-size: 50px;
  font-weight: bolder;
}

.stepperBody {
  font-size: 16px;
}

a {
  text-decoration: none;
  color: #000000;
}
</style>
